// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__7kLSX","rootCenter":"LoadMoreObserver_rootCenter__2Bm9Q","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3U1dP"};